import produce from 'immer';

// UTILS
import { toSelect } from 'utils/genericFunctions';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, TiposDocumentosCompra } from './types';

export const INITIAL_STATE: TiposDocumentosCompra = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): TiposDocumentosCompra {
	return produce(state, draft => {
		switch (action.type) {
			case Types.TIPOS_DOCUMENTOS_COMPRA_REQUEST: {
				break;
			}
			case Types.TIPOS_DOCUMENTOS_COMPRA_SUCCESS: {
				draft.status = action.payload.status;

				if (action.payload.data.dominio) {
					const select = toSelect(
						action.payload.data.dominio,
						'descricao',
						'codigo',
					);
					draft.data = select;
				} else {
					draft.data = [];
				}
				break;
			}
			case Types.TIPOS_DOCUMENTOS_COMPRA_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.TIPOS_DOCUMENTOS_COMPRA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
